export default {
  unsaved: {
    title: 'Enregistrer vos modifications ?',
    description: "Vous avez apporté des modifications à cette étape qui n'ont pas encore été enregistrées.",
    discard: 'Abandonner',
    save_and_continue: 'Enregistrer et continuer',
  },
  title: 'Configurer votre restaurant',
  nav: {
    completed: 'Terminé',
    locked: 'Géré par votre prestataire',
    aria_label: 'Étapes de lancement',
    step_label: 'Étape {{number}}',
    section_label: 'Lancement',
    back_to_home: "Retour à l'accueil",
  },
  owner_invite: {
    hint: 'Vous préférez que le propriétaire du restaurant termine lui-même la configuration ? Invitez-le et il reprendra là où vous en étiez.',
    sent: 'Invitation envoyée à {{name}} ({{email}}) le {{date}}.',
  },
  footer: {
    step_of: 'Étape {{current}} sur {{total}}',
  },
  buttons: {
    next_task: 'Prochaine tâche',
    cancel: 'Annuler',
    back: 'Retour',
    next: 'Continuer',
    save: 'Enregistrer',
    exit: 'Quitter la configuration',
    retry: 'Réessayer',
  },
  errors: {
    progress_load_failed: "Nous n'avons pas pu charger la progression de la configuration de ce restaurant.",
    linked_company_unavailable:
      'Ce lien concerne un restaurant que vous ne pouvez pas ouvrir, vous restez donc sur celui en cours.',
  },
  placeholder: {
    title: 'Cette étape arrive bientôt',
    description:
      "La structure de l'assistant et le suivi de progression sont prêts. Cette phase sera développée ensuite.",
  },
  new_restaurant: {
    title: 'Nouveau restaurant',
    menu: {
      title: 'Menu',
      description: "Une démo ignore l'intégration, importez donc son menu maintenant.",
    },
    demo: {
      title: 'Nouvelle démo',
      description: "Un restaurant de démonstration pour les tests — il ignore la plupart de l'intégration.",
      label: 'Créer une démo',
    },
    description: 'Indiquez-nous où se trouve ce restaurant. Nous le rechercherons sur Google Maps.',
  },
  location: {
    edit_description: "Mettre à jour l'emplacement de ce restaurant.",
    cta: 'Créer le restaurant',
    section: {
      address: 'Informations de base',
      group: 'Marque',
      group_description: "Cet établissement fait-il partie d'une marque que vous avez déjà ?",
    },
    form: {
      name: {
        label: 'Nom du restaurant',
        placeholder: 'Rechercher votre restaurant…',
        help: 'Commencez à taper pour rechercher ce restaurant sur Google Maps.',
      },
      address: {
        label: 'Adresse',
        placeholder: 'Rue et numéro',
      },
      city: {
        label: 'Ville',
      },
      zip_code: {
        label: 'Code postal',
      },
      country: {
        label: 'Pays',
      },
      region: {
        label: 'État / Région',
        placeholder: 'Sélectionner un état ou une région',
      },
    },
    group: {
      aria_label: 'Options de marque',
      deferred_hint: "Vous choisirez le nom de la marque et l'adresse web à la dernière étape.",
      existing: {
        title: 'Ajouter à une marque existante',
        description: "Un autre établissement d'une marque que vous gérez déjà.",
        select_label: 'Marque',
        select_placeholder: 'Sélectionner une marque',
      },
      new: {
        title: 'Créer une nouvelle marque',
        description: "Un restaurant unique, ou le premier établissement d'une nouvelle marque.",
      },
    },
    toasts: {
      update_failed: "Impossible d'enregistrer l'emplacement. Veuillez réessayer.",
      created: 'Restaurant créé',
      create_failed: 'Impossible de créer le restaurant. Veuillez réessayer.',
    },
  },
  domain: {
    url_setup: {
      title: 'Adresse de commande en ligne',
      description: 'Là où les clients passeront commande.',
    },
    modes: {
      foodamigos: {
        host_fallback: 'votre domaine de commande en ligne',
        title: 'Utiliser notre domaine générique',
      },
      custom: {
        title: 'Connecter votre propre domaine',
        description: 'Utilisez un domaine que le restaurant possède déjà.',
      },
    },
    toasts: {
      save_failed: "Impossible d'enregistrer l'adresse de commande en ligne. Veuillez réessayer.",
    },
  },
  go_live: {
    subtitle: 'Vérifiez que chaque étape est effectuée, puis activez les commandes en ligne.',
    slug: {
      // Answers the open question in round-2 §8: PartialUpdateFranchiseRequest
      // carries no go-live guard on the slug, so it can be changed at any time —
      // but there is no redirect table, so the previous address stops resolving.
      // Saying so removes the hesitation without overpromising.
      help: "Lettres, chiffres et tirets uniquement. Vous pouvez la modifier plus tard, mais l'ancienne adresse cessera de fonctionner.",
      title: 'Adresse de commande en ligne',
      description: "C'est ici que vos clients passeront leurs commandes. Vous pouvez la modifier plus tard.",
      label: 'Personnaliser avec le nom du restaurant',
      placeholder: 'bella-italia',
      preview: 'Votre page de commande :',
      save: "Enregistrer l'URL",
      saved: 'Adresse de commande en ligne enregistrée',
      save_failed: "Impossible d'enregistrer l'URL. Veuillez réessayer.",
      status: {
        checking: 'Vérification de la disponibilité…',
        available: 'Disponible',
        taken: 'Cette URL est déjà prise',
        invalid: 'Utilisez uniquement des lettres, chiffres, tirets et underscores',
        error: 'Impossible de vérifier la disponibilité — veuillez réessayer',
      },
    },
    domain: {
      title: 'Domaine personnalisé (facultatif)',
      description: "Utilisez votre propre domaine au lieu de l'adresse fournie par FoodAmigos.",
      add: '+ Ajouter un domaine personnalisé',
      hide: 'Masquer le domaine personnalisé',
      label: 'Votre domaine',
      placeholder: 'boutique.monrestaurant.com',
      save: 'Enregistrer',
      show_records: 'Afficher les enregistrements DNS',
      hint: "Uniquement pour les commandes — votre site web a besoin d'un autre domaine. Par exemple order.monrestaurant.com pour la boutique et monrestaurant.com pour le site web.",
      records_after_save:
        "Dès que vous enregistrez le domaine, nous affichons les enregistrements exacts à ajouter chez votre fournisseur DNS — un domaine principal (monrestaurant.com) et un sous-domaine (order.monrestaurant.com) n'en demandent pas les mêmes.",
      saved: 'Domaine personnalisé enregistré',
      save_failed: "Impossible d'enregistrer le domaine. Veuillez réessayer.",
      unconfirmed: {
        title: "La mise en ligne n'attend pas ce domaine",
        description:
          "Tant que ses enregistrements ne sont pas confirmés, la page de commande reste sur son adresse standard, et le restaurant peut y être mis en ligne. Une fois qu'ils sont confirmés — cela peut prendre jusqu'à 48 heures —, le domaine affiche automatiquement la page de commande.",
      },
    },
    locations: {
      title: 'Confirmer les emplacements',
      description:
        'Chaque établissement de votre marque a sa propre adresse de commande. Confirmez-les ou modifiez-les ci-dessous.',
      save: 'Enregistrer les emplacements',
      saved: 'URL des emplacements enregistrées',
      save_failed: "Impossible d'enregistrer une ou plusieurs URL d'emplacement. Veuillez réessayer.",
    },
    preflight: {
      title: 'Avant de vous mettre en ligne',
      description: 'Effectuez ces étapes pour activer les commandes en ligne.',
      url_setup: 'Adresse de commande configurée',
      online_payment: {
        your_provider: 'votre prestataire',
        payments_live: '{{title}} · terminé',
        online_payments_off: '{{title}} · paiements en ligne désactivés',
        waiting_for_provider: '{{title}} · en attente de {{provider}}',
        hosted_not_finished: '{{title}} · à finaliser avec {{provider}}',
        action_needed: '{{title}} · action requise',
        waiting_for_partner: '{{title}} · en attente de votre partenaire',
        not_set_up: '{{title}} · non configuré',
        business_details_missing: "{{title}} · ajoutez les informations de l'entreprise pour les versements",
      },
    },
    failed_checks: {
      title: 'Quelques points nécessitent encore votre attention',
      items: {
        name: 'Nom du restaurant',
        logo_url: 'Logo',
        pictures: 'Photos de la galerie',
        menu_uploaded: 'Menu',
        opening_hours: "Horaires d'ouverture",
        address: 'Adresse',
        storefront: 'Adresse de commande',
        payments_configured: 'Paiements',
        stripe_billing: 'Facturation',
        test_orders: 'Commande test',
        google_business: 'Profil Google Business',
        master_promo_code: 'Code promo de bienvenue',
        flyers_ordered: 'Flyers commandés',
        identity: 'Type de restaurant & cuisines',
        billing_payment_method: 'Moyen de paiement',
        billing_license: 'Licence',
        business_name: "Nom de l'entreprise / du restaurant",
        payment_method: 'Espèces ou paiements en ligne',
        stripe_processing_fee: 'Frais de traitement du partenaire',
      },
      force: 'Mettre en ligne quand même',
      blocker: '(requis)',
      link: 'Ouvrir Partner Billing',
    },
    error: "Impossible d'activer les commandes en ligne. Veuillez réessayer.",
    gate_hint: 'Complétez la liste ci-dessus pour activer la mise en ligne.',
    business_name: {
      label: "Nom de l'entreprise / du restaurant",
      help: "Affiché dans vos conditions d'utilisation et votre politique de confidentialité. Utilisez le nom sous lequel votre entreprise exerce.",
      save: 'Enregistrer',
      save_failed: "Impossible d'enregistrer le nom de l'entreprise. Veuillez réessayer.",
      hint: "Enregistrez d'abord le nom de l'entreprise / du restaurant.",
    },
    cash_only: {
      message:
        "Les paiements en ligne sont désactivés — les clients ne peuvent payer qu'en espèces au retrait ou à la livraison tant qu'aucun prestataire n'est connecté et vérifié.",
    },
    payment_blocked: {
      title: 'Activez les paiements en espèces ou configurez les paiements en ligne pour passer en ligne.',
      payment_method: "Les clients ont besoin d'un moyen de paiement.",
      turn_on_cash: 'Activer les paiements en espèces',
      ask_partner: "Demandez à votre partenaire d'activer les paiements en espèces, ou",
      set_up_online: 'configurez les paiements en ligne',
    },
    buttons: {
      go_live: 'Mise en ligne 🚀',
      finish: 'Terminer la configuration',
    },
    celebration: {
      title: 'Vous êtes en ligne !',
      title_named: '{{name}} est en ligne !',
      subtitle: 'Votre restaurant accepte désormais les commandes en ligne.',
      license: '{{plan}} · actif',
      license_trial: '{{plan}} · gratuit jusqu’au {{date}}',
      finish: 'Terminer la configuration',
    },
    service_fee: {
      title: 'Frais de service',
      headline: 'Générez des revenus supplémentaires sans facturer vos restaurants',
      subtitle:
        'Ajoutez de petits frais de service que les clients paient à la caisse. Vous en gardez la moitié. Ils restent désactivés tant que vous ne les activez pas.',
      subtitle_share:
        'Ajoutez de petits frais de service que les clients paient à la caisse. Vous en gardez {{share}} %. Ils restent désactivés tant que vous ne les activez pas.',
      tiles: {
        guest: {
          title: 'Payés par le client',
          description: 'Affichés à la caisse, comme sur les applis de livraison.',
        },
        share: {
          title: 'La moitié pour vous',
          title_share: '{{share}} % pour vous',
          description: 'Répartition {{share}}/{{rest}} avec FoodAmigos.',
        },
        choice: {
          title: 'À vous de choisir',
          description: 'Désactivés par défaut. Modifiables à tout moment.',
        },
      },
      preview: {
        title: 'Ce que les clients verraient à la caisse',
        subtotal: 'Sous-total de la commande',
        fee: 'Frais de service',
        fee_terms: '({{percentage}} %, max. {{max}})',
        guest_pays: 'Le client paie',
        split_partner: '<strong>Vous {{amount}}</strong> par commande',
        split_provider: 'FoodAmigos {{amount}}',
        unchanged: 'La valeur de la commande du restaurant reste inchangée.',
      },
      earnings: {
        title: 'Ce que ce restaurant pourrait vous rapporter',
        orders: 'Commandes en ligne par mois',
        average_order: 'Panier moyen',
        per_month: 'par mois pour vous',
        collected: '{{amount}} collectés auprès des clients par mois. Votre part : {{share}} %. Estimation uniquement.',
        effective_rate: "Taux de frais effectif sur l'ensemble des commandes : {{rate}}",
      },
      choice: {
        question: 'Ajouter des frais de service pour ce restaurant ?',
        enabled: {
          title: 'Ajouter des frais de service',
          recommended: 'Recommandé : {{percentage}} %, max. {{max}}',
          description: 'Les clients paient de petits frais. Vous touchez une part.',
        },
        skipped: {
          title: 'Aucun frais de service',
          description: 'Les clients paient uniquement les prix du menu.',
        },
      },
      footer: {
        enabled:
          'Les clients paient {{percentage}} %, max. {{max}} par commande. Modifiable à tout moment dans <settings>Paramètres des commandes → Frais de service</settings>.',
        skipped:
          "Pas de frais de service pour l'instant. Modifiable à tout moment dans <settings>Paramètres des commandes → Frais de service</settings>.",
      },
      enabled:
        "Les frais de service sont désormais activés dans ce restaurant à {{percentage}} %, plafonnés à {{max}} par commande. Ils s'appliquent à toutes les nouvelles commandes à partir de maintenant. Modifiez-les à tout moment dans <settings>Paramètres de commande → Frais de service</settings>.",
      enabled_partner_default:
        "Les frais de service sont désormais activés dans ce restaurant. Votre valeur par défaut de partenaire s'applique : {{percentage}} %, plafonnés à {{max}} par commande. Ils s'appliquent à toutes les nouvelles commandes à partir de maintenant. Modifiez-les à tout moment dans <settings>Paramètres de commande → Frais de service</settings>.",
      buttons: {
        enable: 'Activer les frais de service',
        continue_without: 'Continuer sans frais',
      },
      skipped:
        'Les clients de ce restaurant ne paient aucun frais de service. Vous pouvez les activer à tout moment dans <settings>Paramètres de commande → Frais de service</settings>.',
      toasts: {
        save_failed: "Impossible d'enregistrer le choix des frais de service. Veuillez réessayer.",
      },
    },
  },
  toasts: {
    save_failed: "Impossible d'enregistrer vos modifications. Veuillez réessayer.",
    saved: 'Enregistré',
  },
  optional: 'Facultatif',
  identity: {
    min_cuisine_hint: 'Sélectionnez au moins une cuisine pour continuer.',
    sections: {
      restaurant_type: {
        title: 'Type de restaurant',
        description: "Quel type d'établissement est-ce ?",
      },
      cuisine: {
        title: 'Types de cuisine',
        description: 'Choisissez-en au moins un.',
      },
    },
  },
  menu: {
    modes: {
      recommended: 'Recommandé',
      import: {
        title: 'Importer depuis une plateforme',
        description: 'Importez le menu depuis GloriaFood, Wolt, Lieferando, Deliveroo et plus encore.',
      },
      manual: {
        title: 'Créer votre menu de zéro',
        description: 'Créez des catégories et des articles manuellement dans le générateur de menu.',
      },
    },
    import: {
      title: 'Importer depuis une plateforme existante',
      in_progress: {
        title: 'Importation de votre menu…',
        description:
          'Cela prend généralement moins de deux minutes. Nous compléterons cette étape dès que ce sera terminé.',
      },
      failed: {
        title: "L'importation n'a pas abouti",
        description: "L'importation du menu n'a pas pu être effectuée. Vérifiez les informations et réessayez.",
      },
      blocked: {
        until: "Suspendu jusqu'à {{time}}",
        release: 'Libérer le lien',
        released: "Lien libéré. Vous pouvez relancer l'importation.",
        release_failed: "Le lien n'a pas pu être libéré. Veuillez réessayer dans un instant.",
      },
      stalled: {
        title: 'Importation en cours…',
        description:
          "L'importation prend plus de temps que d'habitude. Elle est peut-être encore en cours en arrière-plan — vérifiez dans un moment. Lancer une nouvelle importation maintenant pourrait importer le menu deux fois.",
      },
    },
    manual: {
      title: 'Créer votre menu de zéro',
      description:
        "Le générateur de menu s'ouvre avec un menu vide. Cette étape est terminée dès qu'au moins une catégorie et un article existent.",
      open_editor: 'Ouvrir le générateur de menu',
      waiting: {
        title: 'En attente de votre premier article de menu',
        description: "Une fois qu'un article est ajouté dans l'éditeur de menu, cette étape peut être complétée.",
      },
      found: {
        title: 'Articles de menu détectés',
        description: "Parfait — vous pouvez passer à l'étape suivante.",
      },
    },
    complete: {
      title: 'Menu prêt',
      description: "Votre menu est en place. Vous pouvez le consulter à tout moment depuis l'éditeur de menu.",
    },
    buttons: {
      start_import: "Démarrer l'importation",
      importing: 'Importation…',
      retry: "Relancer l'importation",
      check_again: 'Vérifier à nouveau',
      continue: 'Continuer',
      skip: "Ignorer pour l'instant",
    },
  },
  phases: {
    // Stands in for the restaurant name in phase descriptions before it is known.
    fallback_name: 'ce restaurant',
    location: {
      title: 'Emplacement',
      description: 'Où se trouve le restaurant et à quelle marque appartient-il ?',
    },
    identity: {
      title: 'Identité',
      description: 'Type de restaurant et cuisines.',
    },
    brand: {
      title: 'Marque',
      description: 'Logo, couleurs et galerie.',
    },
    operations: {
      title: "Détails de l'établissement",
      description:
        "Configurez la façon dont {{name}} prend les commandes. C'est le minimum requis avant de pouvoir recevoir des commandes.",
    },
    menu: {
      title: 'Menu',
      description:
        'Mettez le menu de {{name}} sur la plateforme. Importez-le depuis une plateforme existante en moins de deux minutes, ou créez-le de zéro.',
    },
    domain: {
      title: 'Domaine',
      description: "L'adresse web que les clients utilisent pour commander auprès de ce restaurant.",
    },
    go_live: {
      title: 'Mise en ligne',
      description: 'Activer les commandes en ligne.',
    },
    payouts: {
      title: 'Paiement en ligne',
      description: 'Comment ce restaurant accepte le paiement en ligne.',
    },
    service_fee: {
      title: 'Frais de service',
      description:
        'Indique si les clients paient des frais de service lors du paiement. Vous pouvez le modifier plus tard dans Paramètres de commande → Frais.',
    },
    bank_account: {
      title: 'Compte bancaire',
      description:
        'Où les versements sont envoyés. Pas nécessaire pour la mise en ligne : les paiements restent dans le solde jusqu’à l’ajout d’un compte.',
    },
  },
  business_details: {
    locked:
      'Ces informations sont vérifiées auprès de votre prestataire de paiement. Pour les modifier, contactez FoodAmigos.',
    section: {
      title: "Coordonnées de l'entreprise",
    },
    fields: {
      business_type: {
        label: "Type d'entreprise",
        options: {
          company: 'Entreprise (GmbH, UG, Ltd, Inc — une entité juridique enregistrée)',
          individual: "Entreprise individuelle (vous possédez et gérez l'activité personnellement)",
        },
      },
      owner_first_name: { label: 'Prénom du propriétaire' },
      owner_last_name: { label: 'Nom du propriétaire' },
      legal_name: {
        label: 'Raison sociale',
        individual:
          "Vous gérez l'activité personnellement, le nom du propriétaire est donc utilisé comme raison sociale.",
      },
      legal_address: { label: 'Adresse enregistrée' },
      legal_city: { label: 'Ville' },
      legal_state: { label: 'État ou province' },
      legal_zip_code: { label: 'Code postal' },
      legal_country: { label: 'Pays' },
      tax_id: {
        generic: "Numéro fiscal ou d'immatriculation",
        personal: 'Seuls les quatre derniers chiffres sont affichés. Ne modifiez rien pour conserver le numéro actuel.',
        hint: 'Par exemple {{example}}.',
        invalid:
          "Cela ne correspond pas au format habituel pour ce pays et ce type d'entreprise, par exemple {{example}}.",
      },
      is_vat_registered: { label: 'Cette entreprise est assujettie à la TVA' },
      vat_id: {
        label: 'Numéro de TVA',
        help: 'Commence par {{country}}, suivi de 8 à 12 lettres ou chiffres.',
        invalid: 'Le numéro de TVA doit commencer par {{country}}, suivi de 8 à 12 lettres ou chiffres.',
        help_unprefixed: "Votre numéro de TVA ou d'immatriculation fiscale, tel qu'il a été délivré.",
        invalid_unprefixed: 'Ce numéro ne ressemble pas à un numéro de TVA : utilisez de 5 à 25 lettres ou chiffres.',
      },
    },
    toasts: {
      save_failed: "Impossible d'enregistrer les informations de votre entreprise. Veuillez réessayer.",
    },
  },
  brand: {
    fields: {
      short_name: {
        label: 'Nom court',
        placeholder: 'ex. Amigo Pizza',
        tooltip: "Un nom d'affichage abrégé utilisé sur la vitrine et les reçus.",
      },
      primary_color: {
        label: 'Couleur principale',
        invalid: 'Saisissez une couleur hexadécimale valide, ex. #1A73E8.',
      },
    },
    sections: {
      short_name: 'Nom',
      short_name_hint: 'Utilisé sur la vitrine, les reçus et les notifications.',
      logo_and_colour: 'Logo et couleur principale de marque',
      logo: 'Télécharger le logo',
      logo_hint: 'Si vous laissez ce champ vide, le logo de votre marque sera utilisé.',
      gallery: 'Photos de la galerie',
      gallery_hint: "Ajoutez jusqu'à {{max}} photos de votre restaurant. Faites glisser pour réorganiser.",
      gallery_count: '{{count}} sur {{max}} ajoutées',
    },
    toasts: {
      image_uploaded: 'Image téléchargée',
      image_upload_failed: "Impossible de télécharger l'image. {{error}}",
      save_failed: "Impossible d'enregistrer vos informations de marque. Veuillez réessayer.",
    },
  },
  operations: {
    contact: {
      title: 'Contact',
      description: 'Utilisé pour les notifications de commande et les communications clients.',
      phone: {
        label: 'Numéro de téléphone du restaurant',
        placeholder: '+49 30 1234567',
        invalid: 'Saisissez un numéro de téléphone international complet, ex. +49 30 1234567',
      },
      email: { label: 'E-mail du restaurant', placeholder: 'commandes@restaurant.com' },
    },
    methods: {
      title: 'Modes de commande',
      description: 'Comment les clients peuvent commander et la durée de chaque mode.',
      pickup: {
        label: 'À emporter',
        prep_time: { label: 'Temps de préparation moyen (min)' },
      },
      delivery: {
        label: 'Livraison',
        delivery_time: { label: 'Temps de livraison moyen (min)' },
        advanced_zones: 'Configuration avancée des zones',
      },
    },
    timing: {
      title: 'Horaires de commande',
      description: "Quand les clients peuvent passer commande — immédiatement, plus tard ou à l'avance.",
      at_least_one: 'Activez les commandes immédiates ou planifiées (au moins une est requise).',
      asap: { label: 'Accepter les commandes immédiates' },
      scheduled: { label: 'Accepter les commandes planifiées' },
      reminders: { label: "Envoyer un rappel automatique avant l'échéance d'une commande programmée" },
      pre_order: {
        label: 'Autoriser les précommandes pour les jours à venir',
        days: { label: "Nombre de jours à l'avance (0-31)" },
      },
    },
    tax: {
      title: 'TVA',
      description:
        'Le taux appliqué aux produits de ce restaurant. Il démarre au taux de la région — ne le modifiez que si ce restaurant applique un autre taux.',
      rate: { label: 'Taux de TVA', placeholder: 'ex. 7' },
      dedicated: { label: 'La TVA varie selon le produit' },
    },
    hours: {
      title: "Horaires d'ouverture",
      description: 'Les jours et heures auxquels ce restaurant accepte les commandes.',
      same_every_day: 'Mêmes horaires chaque jour',
      split_shifts: {
        title: "Ce restaurant a des horaires d'ouverture fractionnés",
        description:
          "Certains jours comportent plusieurs périodes d'ouverture (par exemple un service du midi et un service du soir). L'éditeur simplifié affiche une seule période par jour, vos horaires existants sont donc conservés tels quels — modifiez les services fractionnés dans Paramètres de commande → Horaires d'ouverture.",
      },
    },
    toasts: {
      save_failed: "Impossible d'enregistrer vos paramètres opérationnels. Veuillez réessayer.",
    },
  },
  online_payment: {
    question: 'Voulez-vous accepter les paiements en ligne pour ce restaurant ?',
    yes: 'Oui',
    not_now: 'Pas maintenant',
    declined:
      'Les clients paieront au retrait ou à la livraison. Vous pouvez activer les paiements en ligne à tout moment depuis les Paramètres.',
    providers: {
      stripe: 'Stripe',
      adyen: 'Adyen',
    },
    waiting_for_partner: {
      staff: {
        title: 'Les paiements ne sont pas encore configurés pour votre compte partenaire',
        description:
          'Un administrateur de votre compte partenaire doit choisir qui traite les paiements avant que ce restaurant puisse accepter des paiements en ligne. Vous pouvez poursuivre les autres étapes entre-temps.',
      },
    },
    continue_to_go_live: 'Continuer vers la mise en service',
    platform_line: 'Les paiements de ce restaurant passent par les paiements FoodAmigos.',
    only_connection: 'Les paiements passent par {{name}} (votre seul fournisseur connecté).',
    partner_issue: {
      title: 'Votre partenaire {{partner}} doit terminer la configuration de son prestataire de paiement',
      description:
        "Son prestataire de paiement ne peut pas encore intégrer de restaurants. Nous l'avons prévenu — vos informations sont enregistrées, revenez dès qu'il confirme que c'est réglé.",
      retry_hint: 'Une fois le problème résolu, continuez vers le prestataire et nous réessaierons.',
      open_settings: 'Ouvrir les paramètres de votre passerelle de paiement',
    },
    connect_another: 'Connecter un autre fournisseur',
    checking: 'Vérification auprès de {{provider}}…',
    checking_generic: 'Vérification auprès du fournisseur de paiement…',
    retry: 'Réessayer',
    not_set_up: {
      title: "Aucun fournisseur de paiement lié pour l'instant",
      description:
        'Votre partenaire lie un fournisseur de paiement à ce restaurant. Une fois fait, vous pourrez terminer la configuration ici.',
    },
    choice: {
      title: 'Quel fournisseur connecté ce restaurant doit-il utiliser ?',
      primary: 'Principal',
      confirm: 'Utiliser ce fournisseur',
      cancel: 'Annuler',
    },
    using: 'Utilise {{name}}',
    change: 'Modifier',
    payout_details: {
      title: "Informations de l'entreprise pour les versements",
      description:
        'Requises par le prestataire de paiement pour vérifier votre entreprise et effectuer les versements.',
      business_type: {
        company: {
          title: 'Société',
          description: 'GmbH, SARL, Ltd, Inc — une personne morale immatriculée',
        },
        individual: {
          title: 'Particulier',
          description: "Vous possédez et gérez l'entreprise personnellement",
        },
      },
      registered_address: 'Adresse enregistrée',
      legal_address: 'Adresse',
      legal_state: 'État / région',
      vat_id: 'N° de TVA',
      optional: '(facultatif)',
      fill_first: "Remplissez d'abord les informations de l'entreprise pour les versements ci-dessus.",
    },
    hand_off: {
      title: 'Étape suivante : finaliser la configuration avec {{provider}}',
      description:
        "{{provider}} demandera la pièce d'identité du titulaire dans son propre formulaire, à partir des informations d'entreprise pour les versements ci-dessus. Environ 10 minutes. Le compte bancaire vient après la mise en ligne.",
      cta: 'Continuer vers {{provider}}',
      transition: 'Redirection vers {{provider}}…',
      error: "Impossible d'ouvrir le formulaire {{provider}}. Veuillez réessayer.",
    },
    states: {
      verified: 'Les paiements sont actifs.',
      submitted: {
        title: 'Informations envoyées à {{provider}}',
        description:
          'La vérification prend généralement 1 à 2 jours ouvrés. Nous informerons le propriétaire du restaurant par e-mail une fois terminé.',
        description_email:
          'La vérification prend généralement 1 à 2 jours ouvrés. Nous vous enverrons un e-mail à {{email}} une fois terminé.',
        review: {
          business_type: "Type d'entreprise",
          legal_name: 'Nom légal',
          address: 'Adresse enregistrée',
          types: {
            company: 'Société',
            individual: 'Particulier',
          },
        },
      },
      incomplete: {
        title: "Vous n'avez pas terminé avec {{provider}}",
        description: 'Vos informations sont enregistrées — le lien est valable 2 jours.',
        expired: 'Vos informations sont enregistrées, mais le lien a expiré.',
        cta: 'Continuer avec {{provider}}',
        new_link: 'Obtenir un nouveau lien et continuer',
        check_details: "Vérifier d'abord mes informations",
      },
      action_needed: {
        title: "{{provider}} a besoin d'une information supplémentaire",
        description:
          "{{provider}} n'a pas pu vérifier l'une des informations fournies. Rouvrez leur formulaire pour la corriger.",
        cta: 'Rouvrir le formulaire {{provider}}',
      },
    },
    connected: {
      title: 'Les paiements passent par {{name}}',
      description: "Ce restaurant est lié au compte {{name}} — il n'y a rien d'autre à configurer ici.",
      failed: "Nous n'avons pas pu lier ce restaurant à {{name}} pour l'instant",
    },
    errors: {
      generic: "Une erreur s'est produite. Veuillez réessayer.",
      load_failed: 'Impossible de charger la configuration des paiements de ce restaurant.',
    },
  },
  bank_account: {
    section: {
      title: 'Compte bancaire de versement',
      description:
        'Les versements sont effectués en {{currency}}, la devise dans laquelle ce restaurant encaisse ses paiements.',
    },
    done: 'Retour au tableau de bord',
    load_failed: 'Impossible de charger le compte bancaire de ce restaurant.',
    retry: 'Réessayer',
    no_permission: 'Seul le propriétaire du restaurant ou le partenaire peut saisir le compte bancaire.',
    confirm_with_provider: 'Confirmer avec Adyen',
    toasts: {
      save_failed: 'Impossible d’enregistrer le compte bancaire. Veuillez vérifier les informations.',
    },
  },
  payouts: {
    finish_setup: 'Terminer la configuration',
  },
};
